import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-container-standard',
  templateUrl: './container-standard.component.html',
  styleUrls: ['./container-standard.component.css']
})
export class ContainerStandardComponent implements OnInit {

  @Input() title:string;
  constructor() { }

  ngOnInit() {
  }

}
